import { createContext } from 'react';

const useProductSamplingInventoryContext = createContext();
export default useProductSamplingInventoryContext;
